// extracted by mini-css-extract-plugin
export default {"text":"style_text__zYyak","headerTitle":"style_headerTitle__Li+dX","icon":"style_icon__PPfNf"};